export const getPresentationCategoryNameTranslateKey = (category: string): string => {
  return `CONSULTANT.PRESENTATION.CATEGORY_TYPE.${category.toUpperCase()}`;
}